{
  "schemaVersion": "cogo.ux-pattern-definition.v1",
  "uxPatternId": "newsletter-membership-signup",
  "version": "1.0.0",
  "target": "web",
  "intent": "Join the newsletter membership",
  "actorContext": "newsletter-reader",
  "requiredCapabilities": ["join-membership", "update-membership-draft"],
  "preconditions": ["membership-open"],
  "postconditions": ["member-joined"],
  "states": [
    { "stateId": "idle", "statusIntent": "idle" },
    { "stateId": "drafting", "statusIntent": "pending" },
    { "stateId": "joined", "statusIntent": "success" }
  ],
  "transitions": [
    {
      "transitionId": "draft",
      "fromState": "idle",
      "eventRef": "update-draft",
      "toState": "drafting",
      "effectRefs": ["persist-membership-draft"],
      "emitEventRefs": ["membership-draft-updated"]
    },
    {
      "transitionId": "join",
      "fromState": "drafting",
      "eventRef": "submit-membership",
      "toState": "joined",
      "effectRefs": ["append-member"],
      "emitEventRefs": ["membership-joined"]
    }
  ],
  "ports": [
    { "portId": "update-draft", "kind": "event", "direction": "in", "valueType": "cogo.membership-draft", "required": false },
    { "portId": "submit-membership", "kind": "event", "direction": "in", "valueType": "cogo.membership-draft", "required": false },
    { "portId": "membership-draft-updated", "kind": "event", "direction": "out", "valueType": "cogo.membership-draft", "required": true },
    { "portId": "membership-joined", "kind": "event", "direction": "out", "valueType": "cogo.member-id", "required": true }
  ],
  "semanticNodes": [
    {
      "nodeId": "membership-offer",
      "semanticRole": "membership-offer",
      "regionRef": "intro",
      "content": {
        "title": "Turn insight into a membership worth keeping",
        "description": "One focused briefing, member access, and a clear welcome journey."
      },
      "visibleIn": ["idle", "drafting", "joined"]
    },
    {
      "nodeId": "membership-draft",
      "semanticRole": "membership-draft",
      "regionRef": "capture",
      "content": { "label": "Membership email" },
      "visibleIn": ["idle", "drafting"]
    },
    {
      "nodeId": "join-membership",
      "semanticRole": "primary-action",
      "regionRef": "decision",
      "content": { "label": "Join the membership" },
      "visibleIn": ["idle", "drafting"],
      "action": { "role": "primary", "capabilityRef": "join-membership", "slotRef": "decision-primary" }
    }
  ],
  "lineage": {
    "authorityStatus": "consumer-verified",
    "sourceKind": "human-authored-canonical",
    "sourceRefs": ["cogo:approved-source/newsletter-membership-signup-v1"]
  }
}
